var map = {
	"./client/en-US.json": [
		98458,
		458
	],
	"./client/es-419.json": [
		99227,
		227
	],
	"./client/ja.json": [
		93317,
		317
	],
	"./client/pt-BR.json": [
		7583,
		583
	],
	"./client/th.json": [
		21488,
		488
	],
	"./client/zh-CN.json": [
		33664,
		664
	],
	"./client/zh-TW.json": [
		7960,
		960
	],
	"./editor/en-US.json": [
		10972,
		972
	],
	"./editor/es-419.json": [
		79373,
		373
	],
	"./editor/ja.json": [
		74679,
		679
	],
	"./editor/pt-BR.json": [
		41553,
		553
	],
	"./editor/th.json": [
		13062,
		62
	],
	"./editor/zh-CN.json": [
		87294,
		294
	],
	"./editor/zh-TW.json": [
		79626,
		626
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14702;
module.exports = webpackAsyncContext;